var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.value == 0)?_c('i',{staticClass:"fas fa-battery-three-quarters fa-2x",style:({ color: 'green' })}):_vm._e(),(_vm.value == 1)?_c('i',{staticClass:"fas fa-battery-empty fa-2x",style:({ color: 'red' })}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }